module.exports = __webpack_public_path__ + "img/RareCyte_Header_Logo.25708990.png";